// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"475":"da90140f","835":"91b04477"}[chunkId] + ".chunk.js";
};